module.exports = __webpack_public_path__ + "img/createOffice.933be398.svg";